// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Constants
import { USER_ALREADY_REGISTERED } from 'constants/errorCodes'

// Components
import Fade from '@material-ui/core/Fade'
import ItemsGrid from 'atoms/ItemsGrid'
import { ScrollSection } from 'atoms/ScrollSections'
import Link from 'atoms/Link'
import Expand from 'atoms/Expand'
import Plans from 'components/Billing/Plans'
import CouponInput from 'components/Billing/CouponInput'
import CardInput from 'components/Billing/CardInput'
import StepContainer from './StepContainer'
import StepTitle from './StepTitle'
import StepSpacer from './StepSpacer'
import StepButton from './StepButton'
import StepParagraph from './StepParagraph'
import StepError from './StepError'

export default class OnboardingBillingStep extends Component {
  static propTypes = {
    user: PropTypes.object,
    disabled: PropTypes.bool,
    onComplete: PropTypes.func.isRequired,
    onCardChange: PropTypes.func.isRequired,
    submitError: PropTypes.any,
    formData: PropTypes.object.isRequired,
    onFormDataUpdate: PropTypes.func.isRequired,
  }

  state = {
    cardExpanded: false,
    couponExpanded: false,
  }

  completeStep = (sectionProps, skipCard) => () => {
    const { onComplete } = this.props
    onComplete(skipCard)
  }

  handlePlanSelect = (planId) => {
    const { onFormDataUpdate } = this.props
    onFormDataUpdate({ plan: planId })
  }

  toggleCard = () => {
    const { cardExpanded } = this.state
    const { onCardChange } = this.props
    this.setState({ cardExpanded: !cardExpanded }, () => {
      onCardChange(null)
    })
  }

  handleCouponChange = (coupon) => {
    const { onFormDataUpdate } = this.props
    onFormDataUpdate({ coupon })
  }

  toggleCoupon = () => {
    const { couponExpanded } = this.state
    const { onFormDataUpdate } = this.props
    this.setState({ couponExpanded: !couponExpanded }, () => {
      onFormDataUpdate({ coupon: '' })
    })
  }

  renderPlanButtonText = (plan) => {
    return plan.data.monthly.price ? 'Free trial' : 'Select'
  }

  renderContent = (sectionProps) => {
    const { isActive } = sectionProps
    const { disabled, submitError, formData, onCardChange } = this.props
    const { cardExpanded, couponExpanded } = this.state
    const showSkipButton = formData.plan !== 'free'
    const showCard = showSkipButton
    return (
      <StepContainer>
        <StepTitle>Pick a plan</StepTitle>
        <StepSpacer small />
        <Plans
          renderPlanButtonText={this.renderPlanButtonText}
          selectedPlanId={formData.plan}
          onSelect={this.handlePlanSelect}
        />
        <Fade in={showCard} mountOnEnter unmountOnExit>
          <div>
            <StepSpacer small />
            <Expand
              expanded={cardExpanded}
              onToggle={this.toggleCard}
              label="Add credit card"
            >
              <CardInput onChange={onCardChange} />
              {' '}
              :
            </Expand>
          </div>
        </Fade>
        <StepSpacer small />
        <Expand
          expanded={couponExpanded}
          onToggle={this.toggleCoupon}
          label="Enter promo code"
        >
          <CouponInput onChange={this.handleCouponChange} />
        </Expand>
        { !!submitError
          && (
          <Fade in>
            <div>
              <StepSpacer small />
              { submitError.code === USER_ALREADY_REGISTERED
                ? (
                  <StepParagraph>
                    { submitError.message }
                    {', '}
                    <StepButton underline component={Link} to="/login" disabled={disabled}>
                    click here to sign in
                    </StepButton>
                  </StepParagraph>
                )
                : (
                  <StepError>
                    { submitError.message }
                  </StepError>
                )
              }
            </div>
          </Fade>
          )
        }
        <Fade in={isActive}>
          <div>
            <StepSpacer small />
            <ItemsGrid alignItems="baseline">
              <StepButton disabled={disabled} onClick={this.completeStep(sectionProps, false)}>
                Confirm
              </StepButton>
              <Fade in={showSkipButton} mountOnEnter unmountOnExit>
                <StepButton
                  text
                  disabled={disabled}
                  onClick={this.completeStep(sectionProps, true)}
                >
                  skip
                </StepButton>
              </Fade>
            </ItemsGrid>
          </div>
        </Fade>
      </StepContainer>
    )
  }

  render() {
    return (
      <ScrollSection {...this.props}>
        { this.renderContent }
      </ScrollSection>
    )
  }
}
